import { render, staticRenderFns } from "./ChannelCard.vue?vue&type=template&id=1ed8d0c7&scoped=true"
import script from "./ChannelCard.vue?vue&type=script&lang=js"
export * from "./ChannelCard.vue?vue&type=script&lang=js"
import style0 from "./ChannelCard.vue?vue&type=style&index=0&id=1ed8d0c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed8d0c7",
  null
  
)

export default component.exports